// Garden Gnome Software - Skin
// Pano2VR 5.2.2/15983
// Filename: TOYOTA2.ggsk
// Generated 週二 九月 19 13:13:18 2017

const parameterToTransform = function (p) {
  var hs = 'translate(' + p.rx + 'px,' + p.ry + 'px) rotate(' + p.a + 'deg) scale(' + p.sx + ',' + p.sy + ')';
  return hs;
}

const assetPath = '/public/images/Pano2VR'

export default function Pano2vrSkin(player, base) {
  var ggSkinVars = [];
  var me = this;
  var flag = false;
  this.player = player;
  this.player.skinObj = this;
  this.divSkin = player.divSkin;
  this.ggUserdata = me.player.userdata;
  this.lastSize = {
    w: -1,
    h: -1
  };
  var basePath = "";
  // auto detect base path
  if (base == '?') {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      if (src.indexOf('skin.js') >= 0) {
        var p = src.lastIndexOf('/');
        if (p >= 0) {
          basePath = src.substr(0, p + 1);
        }
      }
    }
  } else
  if (base) {
    basePath = base;
  }
  this.elementMouseDown = [];
  this.elementMouseOver = [];
  var cssPrefix = '';
  var domTransition = 'transition';
  var domTransform = 'transform';
  var prefixes = 'Webkit,Moz,O,ms,Ms'.split(',');
  var i;
  if (typeof document.body.style['transform'] == 'undefined') {
    for (var i = 0; i < prefixes.length; i++) {
      if (typeof document.body.style[prefixes[i] + 'Transform'] !== 'undefined') {
        cssPrefix = '-' + prefixes[i].toLowerCase() + '-';
        domTransition = prefixes[i] + 'Transition';
        domTransform = prefixes[i] + 'Transform';
      }
    }
  }

  this.player.setMargins(0, 0, 0, 0);

  this.updateSize = function (startElement) {
    var stack = [];
    stack.push(startElement);
    while (stack.length > 0) {
      var e = stack.pop();
      if (e.ggUpdatePosition) {
        e.ggUpdatePosition();
      }
      if (e.hasChildNodes()) {
        for (var i = 0; i < e.childNodes.length; i++) {
          stack.push(e.childNodes[i]);
        }
      }
    }
  }

  this.findElements = function (id, regex) {
    var r = [];
    var stack = [];
    var pat = new RegExp(id, '');
    stack.push(me.divSkin);
    while (stack.length > 0) {
      var e = stack.pop();
      if (regex) {
        if (pat.test(e.ggId)) r.push(e);
      } else {
        if (e.ggId == id) r.push(e);
      }
      if (e.hasChildNodes()) {
        for (var i = 0; i < e.childNodes.length; i++) {
          stack.push(e.childNodes[i]);
        }
      }
    }
    return r;
  }

  this.addSkin = function () {
    var hs = '';
    this.ggCurrentTime = new Date().getTime();
    this._controller = document.createElement('div');
    this._controller.ggId = "controller";
    this._controller.ggLeft = -96;
    this._controller.ggTop = -55;
    this._controller.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._controller.ggVisible = true;
    this._controller.className = 'ggskin ggskin_container ';
    this._controller.ggType = 'container';
    hs = '';
    hs += 'height : 32px;';
    hs += 'left : -96px;';
    hs += 'position : absolute;';
    hs += 'top : -55px;';
    hs += 'visibility : inherit;';
    hs += 'width : 192px;';
    hs += 'pointer-events:none;';
    this._controller.setAttribute('style', hs);
    this._controller.style[domTransform + 'Origin'] = '50% 50%';
    me._controller.ggIsActive = function () {
      return false;
    }
    me._controller.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    }
    this._controller.ggUpdatePosition = function (useTransition) {
      if (useTransition === 'undefined') {
        useTransition = false;
      }
      if (!useTransition) {
        this.style[domTransition] = 'none';
      }
      if (this.parentNode) {
        var w = this.parentNode.offsetWidth;
        this.style.left = (this.ggLeft - 0 + w / 2) + 'px';
        var h = this.parentNode.offsetHeight;
        this.style.top = (this.ggTop - 0 + h) + 'px';
      }
    }
    this._controller_bg = document.createElement('div');
    this._controller_bg.ggId = "controller_bg";
    this._controller_bg.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._controller_bg.ggVisible = true;
    this._controller_bg.className = 'ggskin ggskin_rectangle ';
    this._controller_bg.ggType = 'rectangle';
    hs = '';
    hs += cssPrefix + 'border-radius : 3px;';
    hs += 'border-radius : 3px;';
    hs += 'background : rgba(63,63,63,0.498039);';
    hs += 'border : 0px solid #000000;';
    hs += 'cursor : default;';
    hs += 'height : 50px;';
    hs += 'left : -9px;';
    hs += 'position : absolute;';
    hs += 'top : -9px;';
    hs += 'visibility : inherit;';
    hs += 'width : 210px;';
    hs += 'pointer-events:auto;';
    this._controller_bg.setAttribute('style', hs);
    this._controller_bg.style[domTransform + 'Origin'] = '50% 50%';
    me._controller_bg.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._controller_bg.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._controller_bg.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._controller_bg);
    this._fullscreen_off = document.createElement('div');
    this._fullscreen_off__img = document.createElement('img');
    this._fullscreen_off__img.className = 'ggskin ggskin_svg';
    this._fullscreen_off__img.setAttribute('src', assetPath + '/fullscreen_off.png');
    this._fullscreen_off__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._fullscreen_off__img['ondragstart'] = function () {
      return false;
    };
    this._fullscreen_off.appendChild(this._fullscreen_off__img);
    this._fullscreen_off__imgo = document.createElement('img');
    this._fullscreen_off__imgo.className = 'ggskin ggskin_svg';
    this._fullscreen_off__imgo.setAttribute('src', assetPath + '/fullscreen_off__o.png');
    this._fullscreen_off__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._fullscreen_off__imgo['ondragstart'] = function () {
      return false;
    };
    this._fullscreen_off.appendChild(this._fullscreen_off__imgo);
    this._fullscreen_off.ggId = "fullscreen_off";
    this._fullscreen_off.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._fullscreen_off.ggVisible = true;
    this._fullscreen_off.className = 'ggskin ggskin_svg ';
    this._fullscreen_off.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 160px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : inherit;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._fullscreen_off.setAttribute('style', hs);
    this._fullscreen_off.style[domTransform + 'Origin'] = '50% 50%';
    me._fullscreen_off.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._fullscreen_off.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._fullscreen_off.onclick = function (e) {
      me.player.exitFullscreen();
    }
    this._fullscreen_off.onmouseover = function (e) {
      me._fullscreen_off__img.style.visibility = 'hidden';
      me._fullscreen_off__imgo.style.visibility = 'inherit';
    }
    this._fullscreen_off.onmouseout = function (e) {
      me._fullscreen_off__img.style.visibility = 'inherit';
      me._fullscreen_off__imgo.style.visibility = 'hidden';
    }
    me._fullscreen_off.ggCurrentLogicStateVisible = -1;
    this._fullscreen_off.ggUpdateConditionResize = function () {
      var newLogicStateVisible;
      if (
        (me.player.getIsFullscreen() == false)
      ) {
        newLogicStateVisible = 0;
      } else {
        newLogicStateVisible = -1;
      }
      if (me._fullscreen_off.ggCurrentLogicStateVisible != newLogicStateVisible) {
        me._fullscreen_off.ggCurrentLogicStateVisible = newLogicStateVisible;
        me._fullscreen_off.style[domTransition] = '';
        if (me._fullscreen_off.ggCurrentLogicStateVisible == 0) {
          me._fullscreen_off.style.visibility = "hidden";
          me._fullscreen_off.ggVisible = false;
        } else {
          me._fullscreen_off.style.visibility = (Number(me._fullscreen_off.style.opacity) > 0 || !me._fullscreen_off.style.opacity) ? 'inherit' : 'hidden';
          me._fullscreen_off.ggVisible = true;
        }
      }
    }
    this._fullscreen_off.ggUpdatePosition = function (useTransition) {
      me._fullscreen_off.ggUpdateConditionResize();
    }
    this._controller.appendChild(this._fullscreen_off);
    this._fullscreen = document.createElement('div');
    this._fullscreen__img = document.createElement('img');
    this._fullscreen__img.className = 'ggskin ggskin_svg';
    this._fullscreen__img.setAttribute('src', assetPath + '/fullscreen.png');
    this._fullscreen__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._fullscreen__img['ondragstart'] = function () {
      return false;
    };
    this._fullscreen.appendChild(this._fullscreen__img);
    this._fullscreen__imgo = document.createElement('img');
    this._fullscreen__imgo.className = 'ggskin ggskin_svg';
    this._fullscreen__imgo.setAttribute('src', assetPath + '/fullscreen__o.png');
    this._fullscreen__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._fullscreen__imgo['ondragstart'] = function () {
      return false;
    };
    this._fullscreen.appendChild(this._fullscreen__imgo);
    this._fullscreen.ggId = "fullscreen";
    this._fullscreen.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._fullscreen.ggVisible = true;
    this._fullscreen.className = 'ggskin ggskin_svg ';
    this._fullscreen.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 160px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : inherit;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._fullscreen.setAttribute('style', hs);
    this._fullscreen.style[domTransform + 'Origin'] = '50% 50%';
    me._fullscreen.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._fullscreen.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._fullscreen.onclick = function (e) {
      me.player.enterFullscreen();
    }
    this._fullscreen.onmouseover = function (e) {
      me._fullscreen__img.style.visibility = 'hidden';
      me._fullscreen__imgo.style.visibility = 'inherit';
    }
    this._fullscreen.onmouseout = function (e) {
      me._fullscreen__img.style.visibility = 'inherit';
      me._fullscreen__imgo.style.visibility = 'hidden';
    }
    me._fullscreen.ggCurrentLogicStateVisible = -1;
    this._fullscreen.ggUpdateConditionResize = function () {
      var newLogicStateVisible;
      if (
        (me.player.getIsFullscreen() == true)
      ) {
        newLogicStateVisible = 0;
      } else {
        newLogicStateVisible = -1;
      }
      if (me._fullscreen.ggCurrentLogicStateVisible != newLogicStateVisible) {
        me._fullscreen.ggCurrentLogicStateVisible = newLogicStateVisible;
        me._fullscreen.style[domTransition] = '';
        if (me._fullscreen.ggCurrentLogicStateVisible == 0) {
          me._fullscreen.style.visibility = "hidden";
          me._fullscreen.ggVisible = false;
        } else {
          me._fullscreen.style.visibility = (Number(me._fullscreen.style.opacity) > 0 || !me._fullscreen.style.opacity) ? 'inherit' : 'hidden';
          me._fullscreen.ggVisible = true;
        }
      }
    }
    this._fullscreen.ggUpdatePosition = function (useTransition) {
      me._fullscreen.ggUpdateConditionResize();
    }
    this._controller.appendChild(this._fullscreen);
    this._movemode_1 = document.createElement('div');
    this._movemode_1__img = document.createElement('img');
    this._movemode_1__img.className = 'ggskin ggskin_svg';
    this._movemode_1__img.setAttribute('src', assetPath + '/movemode_1.png');
    this._movemode_1__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._movemode_1__img['ondragstart'] = function () {
      return false;
    };
    this._movemode_1.appendChild(this._movemode_1__img);
    this._movemode_1__imgo = document.createElement('img');
    this._movemode_1__imgo.className = 'ggskin ggskin_svg';
    this._movemode_1__imgo.setAttribute('src', assetPath + '/movemode_1__o.png');
    this._movemode_1__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._movemode_1__imgo['ondragstart'] = function () {
      return false;
    };
    this._movemode_1.appendChild(this._movemode_1__imgo);
    this._movemode_1.ggId = "movemode_1";
    this._movemode_1.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._movemode_1.ggVisible = false;
    this._movemode_1.className = 'ggskin ggskin_svg ';
    this._movemode_1.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 128px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : hidden;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._movemode_1.setAttribute('style', hs);
    this._movemode_1.style[domTransform + 'Origin'] = '50% 50%';
    me._movemode_1.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._movemode_1.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._movemode_1.onclick = function (e) {
      me.player.changeViewMode(0);
    }
    this._movemode_1.onmouseover = function (e) {
      me._movemode_1__img.style.visibility = 'hidden';
      me._movemode_1__imgo.style.visibility = 'inherit';
    }
    this._movemode_1.onmouseout = function (e) {
      me._movemode_1__img.style.visibility = 'inherit';
      me._movemode_1__imgo.style.visibility = 'hidden';
    }
    me._movemode_1.ggCurrentLogicStateVisible = -1;
    this._movemode_1.ggUpdateConditionTimer = function () {
      var newLogicStateVisible;
      if (
        (me.player.getViewMode() == 1)
      ) {
        newLogicStateVisible = 0;
      } else {
        newLogicStateVisible = -1;
      }
      if (me._movemode_1.ggCurrentLogicStateVisible != newLogicStateVisible) {
        me._movemode_1.ggCurrentLogicStateVisible = newLogicStateVisible;
        me._movemode_1.style[domTransition] = '';
        if (me._movemode_1.ggCurrentLogicStateVisible == 0) {
          me._movemode_1.style.visibility = (Number(me._movemode_1.style.opacity) > 0 || !me._movemode_1.style.opacity) ? 'inherit' : 'hidden';
          me._movemode_1.ggVisible = true;
        } else {
          me._movemode_1.style.visibility = "hidden";
          me._movemode_1.ggVisible = false;
        }
      }
    }
    this._movemode_1.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._movemode_1);
    this._movemode_2 = document.createElement('div');
    this._movemode_2__img = document.createElement('img');
    this._movemode_2__img.className = 'ggskin ggskin_svg';
    this._movemode_2__img.setAttribute('src', assetPath + '/movemode_2.png');
    this._movemode_2__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._movemode_2__img['ondragstart'] = function () {
      return false;
    };
    this._movemode_2.appendChild(this._movemode_2__img);
    this._movemode_2__imgo = document.createElement('img');
    this._movemode_2__imgo.className = 'ggskin ggskin_svg';
    this._movemode_2__imgo.setAttribute('src', assetPath + '/movemode_2__o.png');
    this._movemode_2__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._movemode_2__imgo['ondragstart'] = function () {
      return false;
    };
    this._movemode_2.appendChild(this._movemode_2__imgo);
    this._movemode_2.ggId = "movemode_2";
    this._movemode_2.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._movemode_2.ggVisible = false;
    this._movemode_2.className = 'ggskin ggskin_svg ';
    this._movemode_2.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 128px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : hidden;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._movemode_2.setAttribute('style', hs);
    this._movemode_2.style[domTransform + 'Origin'] = '50% 50%';
    me._movemode_2.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._movemode_2.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._movemode_2.onclick = function (e) {
      me.player.changeViewMode(1);
    }
    this._movemode_2.onmouseover = function (e) {
      me._movemode_2__img.style.visibility = 'hidden';
      me._movemode_2__imgo.style.visibility = 'inherit';
    }
    this._movemode_2.onmouseout = function (e) {
      me._movemode_2__img.style.visibility = 'inherit';
      me._movemode_2__imgo.style.visibility = 'hidden';
    }
    me._movemode_2.ggCurrentLogicStateVisible = -1;
    this._movemode_2.ggUpdateConditionTimer = function () {
      var newLogicStateVisible;
      if (
        (me.player.getViewMode() == 0)
      ) {
        newLogicStateVisible = 0;
      } else {
        newLogicStateVisible = -1;
      }
      if (me._movemode_2.ggCurrentLogicStateVisible != newLogicStateVisible) {
        me._movemode_2.ggCurrentLogicStateVisible = newLogicStateVisible;
        me._movemode_2.style[domTransition] = '';
        if (me._movemode_2.ggCurrentLogicStateVisible == 0) {
          me._movemode_2.style.visibility = (Number(me._movemode_2.style.opacity) > 0 || !me._movemode_2.style.opacity) ? 'inherit' : 'hidden';
          me._movemode_2.ggVisible = true;
        } else {
          me._movemode_2.style.visibility = "hidden";
          me._movemode_2.ggVisible = false;
        }
      }
    }
    this._movemode_2.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._movemode_2);
    this._autorotate = document.createElement('div');
    this._autorotate__img = document.createElement('img');
    this._autorotate__img.className = 'ggskin ggskin_svg';
    this._autorotate__img.setAttribute('src', assetPath + '/autorotate.png');
    this._autorotate__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._autorotate__img['ondragstart'] = function () {
      return false;
    };
    this._autorotate.appendChild(this._autorotate__img);
    this._autorotate__imgo = document.createElement('img');
    this._autorotate__imgo.className = 'ggskin ggskin_svg';
    this._autorotate__imgo.setAttribute('src', assetPath + '/autorotate__o.png');
    this._autorotate__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._autorotate__imgo['ondragstart'] = function () {
      return false;
    };
    this._autorotate.appendChild(this._autorotate__imgo);
    this._autorotate.ggId = "autorotate";
    this._autorotate.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._autorotate.ggVisible = true;
    this._autorotate.className = 'ggskin ggskin_svg ';
    this._autorotate.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 64px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : inherit;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._autorotate.setAttribute('style', hs);
    this._autorotate.style[domTransform + 'Origin'] = '50% 50%';
    me._autorotate.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._autorotate.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._autorotate.onclick = function (e) {
      me.player.startAutorotate("0.2", "5", "1");
    }
    this._autorotate.onmouseover = function (e) {
      me._autorotate__img.style.visibility = 'hidden';
      me._autorotate__imgo.style.visibility = 'inherit';
    }
    this._autorotate.onmouseout = function (e) {
      me._autorotate__img.style.visibility = 'inherit';
      me._autorotate__imgo.style.visibility = 'hidden';
    }
    me._autorotate.ggCurrentLogicStateVisible = -1;
    this._autorotate.ggUpdateConditionTimer = function () {
      var newLogicStateVisible;
      if (
        (me.player.getIsAutorotating() == true)
      ) {
        newLogicStateVisible = 0;
      } else {
        newLogicStateVisible = -1;
      }
      if (me._autorotate.ggCurrentLogicStateVisible != newLogicStateVisible) {
        me._autorotate.ggCurrentLogicStateVisible = newLogicStateVisible;
        me._autorotate.style[domTransition] = '';
        if (me._autorotate.ggCurrentLogicStateVisible == 0) {
          me._autorotate.style.visibility = "hidden";
          me._autorotate.ggVisible = false;
        } else {
          me._autorotate.style.visibility = (Number(me._autorotate.style.opacity) > 0 || !me._autorotate.style.opacity) ? 'inherit' : 'hidden';
          me._autorotate.ggVisible = true;
        }
      }
    }
    this._autorotate.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._autorotate);
    this._autorotate_off = document.createElement('div');
    this._autorotate_off__img = document.createElement('img');
    this._autorotate_off__img.className = 'ggskin ggskin_svg';
    this._autorotate_off__img.setAttribute('src', assetPath + '/autorotate_off.png');
    this._autorotate_off__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._autorotate_off__img['ondragstart'] = function () {
      return false;
    };
    this._autorotate_off.appendChild(this._autorotate_off__img);
    this._autorotate_off__imgo = document.createElement('img');
    this._autorotate_off__imgo.className = 'ggskin ggskin_svg';
    this._autorotate_off__imgo.setAttribute('src', assetPath + '/autorotate_off__o.png');
    this._autorotate_off__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._autorotate_off__imgo['ondragstart'] = function () {
      return false;
    };
    this._autorotate_off.appendChild(this._autorotate_off__imgo);
    this._autorotate_off.ggId = "autorotate_off";
    this._autorotate_off.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._autorotate_off.ggVisible = false;
    this._autorotate_off.className = 'ggskin ggskin_svg ';
    this._autorotate_off.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 64px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : hidden;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._autorotate_off.setAttribute('style', hs);
    this._autorotate_off.style[domTransform + 'Origin'] = '50% 50%';
    me._autorotate_off.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._autorotate_off.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._autorotate_off.onclick = function (e) {
      me.player.stopAutorotate();
    }
    this._autorotate_off.onmouseover = function (e) {
      me._autorotate_off__img.style.visibility = 'hidden';
      me._autorotate_off__imgo.style.visibility = 'inherit';
    }
    this._autorotate_off.onmouseout = function (e) {
      me._autorotate_off__img.style.visibility = 'inherit';
      me._autorotate_off__imgo.style.visibility = 'hidden';
    }
    me._autorotate_off.ggCurrentLogicStateVisible = -1;
    this._autorotate_off.ggUpdateConditionTimer = function () {
      var newLogicStateVisible;
      if (
        (me.player.getIsAutorotating() == true)
      ) {
        newLogicStateVisible = 0;
      } else {
        newLogicStateVisible = -1;
      }
      if (me._autorotate_off.ggCurrentLogicStateVisible != newLogicStateVisible) {
        me._autorotate_off.ggCurrentLogicStateVisible = newLogicStateVisible;
        me._autorotate_off.style[domTransition] = '';
        if (me._autorotate_off.ggCurrentLogicStateVisible == 0) {
          me._autorotate_off.style.visibility = (Number(me._autorotate_off.style.opacity) > 0 || !me._autorotate_off.style.opacity) ? 'inherit' : 'hidden';
          me._autorotate_off.ggVisible = true;
        } else {
          me._autorotate_off.style.visibility = "hidden";
          me._autorotate_off.ggVisible = false;
        }
      }
    }
    this._autorotate_off.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._autorotate_off);
    this._zoomout = document.createElement('div');
    this._zoomout__img = document.createElement('img');
    this._zoomout__img.className = 'ggskin ggskin_svg';
    this._zoomout__img.setAttribute('src', assetPath + '/zoomout.png');
    this._zoomout__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._zoomout__img['ondragstart'] = function () {
      return false;
    };
    this._zoomout.appendChild(this._zoomout__img);
    this._zoomout__imgo = document.createElement('img');
    this._zoomout__imgo.className = 'ggskin ggskin_svg';
    this._zoomout__imgo.setAttribute('src', assetPath + '/zoomout__o.png');
    this._zoomout__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._zoomout__imgo['ondragstart'] = function () {
      return false;
    };
    this._zoomout.appendChild(this._zoomout__imgo);
    this._zoomout.ggId = "zoomout";
    this._zoomout.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._zoomout.ggVisible = true;
    this._zoomout.className = 'ggskin ggskin_svg ';
    this._zoomout.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 32px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : inherit;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._zoomout.setAttribute('style', hs);
    this._zoomout.style[domTransform + 'Origin'] = '50% 50%';
    me._zoomout.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._zoomout.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._zoomout.onmouseover = function (e) {
      me._zoomout__img.style.visibility = 'hidden';
      me._zoomout__imgo.style.visibility = 'inherit';
    }
    this._zoomout.onmouseout = function (e) {
      me._zoomout__img.style.visibility = 'inherit';
      me._zoomout__imgo.style.visibility = 'hidden';
      me.elementMouseDown['zoomout'] = false;
    }
    this._zoomout.onmousedown = function (e) {
      me.elementMouseDown['zoomout'] = true;
    }
    this._zoomout.onmouseup = function (e) {
      me.elementMouseDown['zoomout'] = false;
    }
    this._zoomout.ontouchend = function (e) {
      me.elementMouseDown['zoomout'] = false;
    }
    this._zoomout.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._zoomout);
    this._zoomin = document.createElement('div');
    this._zoomin__img = document.createElement('img');
    this._zoomin__img.className = 'ggskin ggskin_svg';
    this._zoomin__img.setAttribute('src', assetPath + '/zoomin.png');
    this._zoomin__img.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;pointer-events:none;');
    this._zoomin__img['ondragstart'] = function () {
      return false;
    };
    this._zoomin.appendChild(this._zoomin__img);
    this._zoomin__imgo = document.createElement('img');
    this._zoomin__imgo.className = 'ggskin ggskin_svg';
    this._zoomin__imgo.setAttribute('src', assetPath + '/zoomin__o.png');
    this._zoomin__imgo.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;-webkit-user-drag:none;visibility:hidden;pointer-events:none;');
    this._zoomin__imgo['ondragstart'] = function () {
      return false;
    };
    this._zoomin.appendChild(this._zoomin__imgo);
    this._zoomin.ggId = "zoomin";
    this._zoomin.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._zoomin.ggVisible = true;
    this._zoomin.className = 'ggskin ggskin_svg ';
    this._zoomin.ggType = 'svg';
    hs = '';
    hs += 'cursor : pointer;';
    hs += 'height : 32px;';
    hs += 'left : 0px;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : inherit;';
    hs += 'width : 32px;';
    hs += 'pointer-events:auto;';
    this._zoomin.setAttribute('style', hs);
    this._zoomin.style[domTransform + 'Origin'] = '50% 50%';
    me._zoomin.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._zoomin.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._zoomin.onmouseover = function (e) {
      me._zoomin__img.style.visibility = 'hidden';
      me._zoomin__imgo.style.visibility = 'inherit';
    }
    this._zoomin.onmouseout = function (e) {
      me._zoomin__img.style.visibility = 'inherit';
      me._zoomin__imgo.style.visibility = 'hidden';
      me.elementMouseDown['zoomin'] = false;
    }
    this._zoomin.onmousedown = function (e) {
      me.elementMouseDown['zoomin'] = true;
    }
    this._zoomin.onmouseup = function (e) {
      me.elementMouseDown['zoomin'] = false;
    }
    this._zoomin.ontouchend = function (e) {
      me.elementMouseDown['zoomin'] = false;
    }
    this._zoomin.ggUpdatePosition = function (useTransition) {}
    this._controller.appendChild(this._zoomin);
    this.divSkin.appendChild(this._controller);
    this._loading = document.createElement('div');
    this._loading.ggId = "loading";
    this._loading.ggLeft = -105;
    this._loading.ggTop = -30;
    this._loading.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._loading.ggVisible = true;
    this._loading.className = 'ggskin ggskin_container ';
    this._loading.ggType = 'container';
    hs = '';
    hs += 'height : 60px;';
    hs += 'left : -105px;';
    hs += 'position : absolute;';
    hs += 'top : -30px;';
    hs += 'visibility : inherit;';
    hs += 'width : 210px;';
    hs += 'pointer-events:none;';
    this._loading.setAttribute('style', hs);
    this._loading.style[domTransform + 'Origin'] = '50% 50%';
    me._loading.ggIsActive = function () {
      return false;
    }
    me._loading.ggElementNodeId = function () {
      return me.player.getCurrentNode();
    }
    this._loading.onclick = function (e) {
      me._loading.style[domTransition] = 'none';
      me._loading.style.visibility = 'hidden';
      me._loading.ggVisible = false;
    }
    this._loading.ggUpdatePosition = function (useTransition) {
      if (useTransition === 'undefined') {
        useTransition = false;
      }
      if (!useTransition) {
        this.style[domTransition] = 'none';
      }
      if (this.parentNode) {
        var w = this.parentNode.offsetWidth;
        this.style.left = (this.ggLeft - 0 + w / 2) + 'px';
        var h = this.parentNode.offsetHeight;
        this.style.top = (this.ggTop - 0 + h / 2) + 'px';
      }
    }
    this._loadingbg = document.createElement('div');
    this._loadingbg.ggId = "loadingbg";
    this._loadingbg.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._loadingbg.ggVisible = true;
    this._loadingbg.className = 'ggskin ggskin_rectangle ';
    this._loadingbg.ggType = 'rectangle';
    hs = '';
    hs += 'background : rgba(0,0,0,0.666667);';
    hs += 'border : 0px solid #000000;';
    hs += 'cursor : default;';
    hs += 'height : 60px;';
    hs += 'left : 0px;';
    hs += 'opacity : 0.5;';
    hs += 'position : absolute;';
    hs += 'top : 0px;';
    hs += 'visibility : inherit;';
    hs += 'width : 210px;';
    hs += 'pointer-events:auto;';
    this._loadingbg.setAttribute('style', hs);
    this._loadingbg.style[domTransform + 'Origin'] = '50% 50%';
    me._loadingbg.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._loadingbg.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._loadingbg.ggUpdatePosition = function (useTransition) {}
    this._loading.appendChild(this._loadingbg);
    this._loadingtext = document.createElement('div');
    this._loadingtext__text = document.createElement('div');
    this._loadingtext.className = 'ggskin ggskin_textdiv';
    this._loadingtext.ggTextDiv = this._loadingtext__text;
    this._loadingtext.ggId = "loadingtext";
    this._loadingtext.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._loadingtext.ggVisible = true;
    this._loadingtext.className = 'ggskin ggskin_text ';
    this._loadingtext.ggType = 'text';
    hs = '';
    hs += 'height : 23px;';
    hs += 'left : 16px;';
    hs += 'position : absolute;';
    hs += 'top : 12px;';
    hs += 'visibility : inherit;';
    hs += 'width : 176px;';
    hs += 'pointer-events:auto;';
    this._loadingtext.setAttribute('style', hs);
    this._loadingtext.style[domTransform + 'Origin'] = '0% 50%';
    hs = 'position:absolute;';
    hs += 'cursor: default;';
    hs += 'left: 0px;';
    hs += 'top:  0px;';
    hs += 'width: auto;';
    hs += 'height: auto;';
    hs += 'border: 0px solid #000000;';
    hs += 'color: rgba(255,255,255,1);';
    hs += 'text-align: left;';
    hs += 'white-space: nowrap;';
    hs += 'padding: 0px 1px 0px 1px;';
    hs += 'overflow: hidden;';
    this._loadingtext__text.setAttribute('style', hs);
    this._loadingtext.ggUpdateText = function () {
      var hs = "Loading... " + (me.player.getPercentLoaded() * 100.0).toFixed(0) + "%";
      if (hs != this.ggText) {
        this.ggText = hs;
        this.ggTextDiv.innerHTML = hs;
        if (this.ggUpdatePosition) this.ggUpdatePosition();
      }
    }
    me._loadingtext.ggUpdateText();
    this._loadingtext.appendChild(this._loadingtext__text);
    me._loadingtext.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._loadingtext.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._loadingtext.ggUpdatePosition = function (useTransition) {}
    this._loading.appendChild(this._loadingtext);
    this._loadingbar = document.createElement('div');
    this._loadingbar.ggId = "loadingbar";
    this._loadingbar.ggParameter = {
      rx: 0,
      ry: 0,
      a: 0,
      sx: 1,
      sy: 1
    };
    this._loadingbar.ggVisible = true;
    this._loadingbar.className = 'ggskin ggskin_rectangle ';
    this._loadingbar.ggType = 'rectangle';
    hs = '';
    hs += 'background : #ffffff;';
    hs += 'border : 0px solid #808080;';
    hs += 'cursor : default;';
    hs += 'height : 13px;';
    hs += 'left : 15px;';
    hs += 'position : absolute;';
    hs += 'top : 35px;';
    hs += 'visibility : inherit;';
    hs += 'width : 182px;';
    hs += 'pointer-events:auto;';
    this._loadingbar.setAttribute('style', hs);
    this._loadingbar.style[domTransform + 'Origin'] = '0% 50%';
    me._loadingbar.ggIsActive = function () {
      if ((this.parentNode) && (this.parentNode.ggIsActive)) {
        return this.parentNode.ggIsActive();
      }
      return false;
    }
    me._loadingbar.ggElementNodeId = function () {
      if ((this.parentNode) && (this.parentNode.ggElementNodeId)) {
        return this.parentNode.ggElementNodeId();
      }
      return me.player.getCurrentNode();
    }
    this._loadingbar.ggUpdatePosition = function (useTransition) {}
    this._loading.appendChild(this._loadingbar);
    this.divSkin.appendChild(this._loading);
    this.divSkin.ggUpdateSize = function (w, h) {
      me.updateSize(me.divSkin);
    }
    this.divSkin.ggViewerInit = function () {}
    this.divSkin.ggLoaded = function () {
      me._loading.style[domTransition] = 'none';
      me._loading.style.visibility = 'hidden';
      me._loading.ggVisible = false;
    }
    this.divSkin.ggReLoaded = function () {
      me._loading.style[domTransition] = 'none';
      me._loading.style.visibility = (Number(me._loading.style.opacity) > 0 || !me._loading.style.opacity) ? 'inherit' : 'hidden';
      me._loading.ggVisible = true;
    }
    this.divSkin.ggLoadedLevels = function () {}
    this.divSkin.ggReLoadedLevels = function () {}
    this.divSkin.ggEnterFullscreen = function () {}
    this.divSkin.ggExitFullscreen = function () {}
    this.skinTimerEvent();
  };
  this.hotspotProxyClick = function (id) {}
  this.hotspotProxyOver = function (id) {}
  this.hotspotProxyOut = function (id) {}
  this.changeActiveNode = function (id) {
    me.ggUserdata = me.player.userdata;
  }
  this.skinTimerEvent = function () {
    setTimeout(function () {
      me.skinTimerEvent();
    }, 10);
    me.ggCurrentTime = new Date().getTime();
    me._movemode_1.ggUpdateConditionTimer();
    me._movemode_2.ggUpdateConditionTimer();
    me._autorotate.ggUpdateConditionTimer();
    me._autorotate_off.ggUpdateConditionTimer();
    if (me.elementMouseDown['zoomout']) {
      me.player.changeFovLog(1, true);
    }
    if (me.elementMouseDown['zoomin']) {
      me.player.changeFovLog(-1, true);
    }
    me._loadingtext.ggUpdateText();
    var hs = '';
    if (me._loadingbar.ggParameter) {
      hs += parameterToTransform(me._loadingbar.ggParameter) + ' ';
    }
    hs += 'scale(' + (1 * me.player.getPercentLoaded() + 0) + ',1.0) ';
    me._loadingbar.style[domTransform] = hs;
  };
  this.addSkin();
};